/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import React from 'react';
import './Commentary.scss';
import ShareClassConversionModal from 'components/shared/ShareClassConversion/ShareClassConversionModal';
import {portfolioGrowthAccountsWithShareClassMessageEnabled} from 'services/FeatureFlags';

const Commentary = (props) => {

  const { shareClass, commentary } = props;
  return (
    <div className="commentary">
      <p>Observations</p>
      <ul>
        {commentary.map((comment, i) => (
          <li key={i}>
            <span dangerouslySetInnerHTML={{ __html: comment }}></span>
          </li>
        ))}
        {portfolioGrowthAccountsWithShareClassMessageEnabled() && shareClass && (
          <li>
            <div>
              <span className="share-class-text">{shareClass}
                <span className="share-class-modal">
                  <ShareClassConversionModal />
                </span>
              </span>
            </div>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Commentary;
